// Check https://github.com/markdown-it/markdown-it/blob/master/docs/architecture.md
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};

(function (mod){ //[HyperMD] UMD patched!
  /*commonjs*/  ("object"==typeof exports&&"undefined"!=typeof module) ? mod(null, exports, require("markdown-it-for-inline"), require("../heading-id-generator")) :
  /*amd*/       ("function"==typeof define&&define.amd) ? define(["require","exports","markdown-it-for-inline","../heading-id-generator"], mod) :
  /*plain env*/ mod(null, (this.HyperMD.PreviewFeatureLink = this.HyperMD.PreviewFeatureLink || {}), MarkdownItForInline, HyperMD.PreviewHeadingIDGenerator);
})(function (require, exports, markdown_it_for_inline_1, heading_id_generator_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    markdown_it_for_inline_1 = __importDefault(markdown_it_for_inline_1);
    // Override the default `link` functionality
    exports.default = (function (md) {
        md.use(markdown_it_for_inline_1.default, "link_with_id", "link_open", function (tokens, idx) {
            var token = tokens[idx];
            var hrefIndex = token.attrIndex("href");
            if (hrefIndex >= 0) {
                var href = token.attrs[hrefIndex][1];
                token.attrPush(["id", "link-" + heading_id_generator_1.uslug(href) + "-" + idx]);
            }
        });
    });
});
